<template>
  <div id="gkmg-destination-order-list" v-if="isShowUploadCsv">
    <div class="card vx-card p-6">
      <div class="menu-section">
        <div class="header">
          <div class="icon-area">
            <feather-icon
              class="mr-2"
              icon="DownloadIcon"
              svgClasses="h-7 w-7"
            />
          </div>
          <div class="title">一括取込み</div>
        </div>
        <div class="menu-content">
          <div class="description">
            一括取込するファイルを選択してください。
          </div>
          <label for="file_upload" class="input">
            {{ excelData ? excelData.name : "ファイルを選択" }}
            <input type="file" id="file_upload" @change="onExcelUploaded" />
          </label>

          <div class="menu-button-area">
            <vs-button
              class="menu-button"
              color="#2D9CDB"
              :disabled="uploadButtonDisabled"
              @click="clickUpload"
            >
              <span class="import-button-inner"> アップロード </span>
            </vs-button>
            <vs-button
              class="menu-button"
              color="#bdbdbd"
              :to="{ name: 'addon-gkmg-port-master-port-menu' }"
            >
              <span class="import-button-inner"> キャンセル </span>
            </vs-button>
            <!-- excelファイルアップロード成功後、一覧表へ遷移するか確認する画面ポップアップ -->
            <vs-popup
              class="report-download-popup"
              style="text-align: center"
              title="アップロードが完了しました。"
              :active.sync="isPopupActive"
            >
              <div>
                <span>一覧表を閲覧しますか？</span>
              </div>
              <div class="button-area">
                <vs-button
                  class="popup-button"
                  style="margin: 3px"
                  color="#2D9CDB"
                  @click="jumpToDestinationWorkList"
                  >閲覧する</vs-button
                >
                <vs-button
                  class="popup-button"
                  style="margin: 3px"
                  color="#bdbdbd"
                  @click="changePopupState(false)"
                  >閲覧しない</vs-button
                >
              </div>
            </vs-popup>
          </div>
        </div>
      </div>
    </div>
    <vs-popup
      class="basic-master-popup"
      title="新規データ登録の確認"
      :active.sync="popupActive"
      :button-close-hidden="true"
    >
      <p class="important-message">
        選択した取込みデータの中に新しい登録情報があります。
      </p>
      <p class="message">
        個別の管理画面から新規データの確認、詳細データを追加してください。
      </p>
      <div class="popup-list">
        <div
          class="popup-list-item"
          v-for="(item, index) in addDataItems"
          :key="index"
        >
          <div class="item-name">
            {{ item.name }}
          </div>
          <div class="item-column-name">
            {{ item.columnName }}
          </div>
        </div>
      </div>
      <div class="button-area">
        <vs-button class="popup-button" color="#2D9CDB" @click="clickConfirm"
          >一括取込み確認画面</vs-button
        >
      </div>
    </vs-popup>
    <vs-popup
      class="basic-master-popup"
      :title="customErrorTitle || '登録データの不足'"
      :active.sync="popupErrorActive"
    >
      <template v-if="!customErrorMessage">
        <p class="important-message">以下の対象データが入力されていません。</p>
        <p class="message">
          元の一括取込ファイルを修正して、再度取り込んでください。
        </p>
        <div class="popup-list">
          <div
            class="popup-list-item"
            v-for="(message, index) in errorMessages"
            :key="index"
          >
            <div class="item-name">
              {{ message }}
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <p class="important-message">
          {{ customErrorMessage }}
        </p>
      </template>
      <div class="close-button-area">
        <vs-button
          class="popup-close-button"
          color="#2D9CDB"
          @click="popupErrorActive = false"
          >閉じる</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moment from "moment";
import { createNamespacedHelpers } from "vuex";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
const { mapActions, mapGetters } = createNamespacedHelpers("gkmgPortMaster");
const { mapActions: mapActionsOfGkmgPortMasterDestinationWork } =
  createNamespacedHelpers("gkmgPortMasterDestinationWork");

export default {
  data() {
    return {
      selectedControl: null,
      configDayPicker: {
        dateFormat: "Y-m-d",
        time_24hr: true,
        defaultDate: new Date(),
        enable: [],
        locale: Japanese,
        static: true,
      },
      excelData: null,
      popupActive: false,
      popupErrorActive: false,
      addDataItems: [],
      errorMessages: [],
      customErrorTitle: null,
      customErrorMessage: null,
      isPopupActive: false,
    };
  },
  async mounted() {
    if (this.hasAddonGkmgPortMaster) {
      await this.getGkmgPortMasterAuth();
    }
    if (!this.isShowUploadCsv) return;
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";
  },
  computed: {
    ...mapGetters(["gkmgPortMasterAuth", "hasAddonGkmgPortMaster"]),
    uploadButtonDisabled() {
      return this.excelData == null;
    },
    isShowUploadCsv() {
      // this.gkmgPortMasterAuthは元はconst.jsのGKMG_AUTH_MASTERを見ているため、必ずPortMenu.uploadCsvを持つ
      return (
        this.hasAddonGkmgPortMaster &&
        this.gkmgPortMasterAuth.PortMenu.uploadCsv
      );
    },
  },
  methods: {
    ...mapActions(["getGkmgPortMasterAuth"]),
    ...mapActionsOfGkmgPortMasterDestinationWork([
      "setSelectedDate",
      "importTask",
    ]),
    async clickUpload() {
      let payload = {
        file: this.excelData,
      };
      this.$vs.loading();
      let res = await this.importTask(payload);
      /*
       * アップロード後に入出港予定一覧表へ遷移する場合のために、遷移時の表示日付を格納する。
       * TODO: アップロード後に、どの日付を指定して入出港予定一覧表を出力するかは、
       *       APIから日付が返却されることになるようなので、APIの修正がされたのちに、以下のselectedDateの設定も修正の必要あり。
       */
      const selectedDate = moment().local().format("YYYY/MM/DD");
      this.setSelectedDate(selectedDate);
      if (!res.status) {
        this.$vs.loading.close();
        this.customErrorTitle = "エラー";
        this.customErrorMessage = res.message;
        this.popupErrorActive = true;
      } else {
        this.$vs.loading.close();
        this.changePopupState(true);
      }
    },
    jumpToDestinationWorkList() {
      this.$router.push({
        name: "addon-gkmg-port-master-destination-work-display",
      });
    },
    changePopupState(bool) {
      this.isPopupActive = bool;
    },
    clickConfirm() {
      this.popupActive = false;
      this.$router.push({
        name: "addon-gkmg-port-master-destination-imported-work-edit",
      });
    },
    onExcelUploaded(e) {
      const excel = e.target.files[0];
      this.excelData = excel;
    },
    clickOrderItem() {
      this.$router.push({
        name: "addon-gkmg-port-master-destination-work-edit",
      });
    },
    dateChipText(date) {
      let today = moment(new Date()).format("YYYY/MM/DD");
      let tomorrow = moment(new Date()).add(1, "days").format("YYYY/MM/DD");
      let dayAfterTomorrow = moment(new Date())
        .add(2, "days")
        .format("YYYY/MM/DD");
      let yesterday = moment(new Date())
        .subtract(1, "days")
        .format("YYYY/MM/DD");
      let dayBeforeYesterday = moment(new Date())
        .subtract(2, "days")
        .format("YYYY/MM/DD");
      if (date == today) {
        return "当日分";
      } else if (date == tomorrow) {
        return "翌日分";
      } else if (date == dayAfterTomorrow) {
        return "翌々日分";
      } else if (date == yesterday) {
        return "前日分";
      } else if (date == dayBeforeYesterday) {
        return "前々日分";
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
#gkmg-destination-order-list {
  .card {
    margin-top: 30px;
  }
  .menu-section {
    margin: 10px 0px;
  }
  .header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .icon-area {
      width: 36px;
    }
  }
  .flatpickr-input.active {
    border: 1px solid $pm-blue;
  }
  label > input {
    display: none;
  }
  label {
    color: #626262;
    padding: 10px;
    border: solid 1px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    cursor: pointer;
  }
  .menu-button-area {
    margin: 40px 0px 20px 0px;
    .menu-button {
      margin-right: 15px;
    }
  }
  .description {
    margin-bottom: 10px;
  }
  .menu-content {
    margin-left: 45px;
  }
  .title {
    font-weight: bold;
  }
  .input-label {
    font-weight: bold;
  }
  .import-label {
    margin-bottom: 19px;
  }
  .input {
    margin-bottom: 20px;
    margin-top: 10px;
  }
  .flatpickr-day.selected {
    background: $pm-blue !important;
    border-color: $pm-blue !important;
    &:hover {
      background: $pm-blue !important;
      border-color: $pm-blue !important;
    }
  }
  .basic-master-popup {
    .popup-list {
      background: $pm-paper-white;
      overflow-y: scroll;
      padding: 0px 10px;
      max-height: 230px;
      margin: 20px 0px;
    }
    .popup-list-item {
      margin: 8px 0px;
      display: flex;
      justify-content: space-between;
    }
    .item-name,
    .important-message {
      font-weight: bold;
    }
    .item-column-name {
      margin-right: 10px;
    }
    .important-message {
      margin-bottom: 10px;
    }
    .popup-close-button {
      margin-left: auto;
      margin-right: auto;
      display: block;
    }
    .popup-button {
      margin-left: 10px;
    }
    .button-area {
      width: fit-content;
      margin-top: 20px;
      margin-left: auto;
    }
  }
}
</style>
